<template>
  <div class="qhls-exam-center">
    <div class="page-header">
      <p class="page-subtitle mal-text">QHLS പരീക്ഷാ കേന്ദ്ര വിവരങ്ങൾ നൽകുക</p>
    </div>

    <div v-if="canAddCenter && isWing2" class="add-btn-wrap">
      <button type="button" class="btn btn-primary btn-block add-btn" @click="openAddModal">
        <ion-icon name="add-outline"></ion-icon>
        <span class="mal-text">ചേർക്കുക (Add)</span>
      </button>
    </div>

    <div v-if="!isWing2" class="empty-note mal-text">
      ഈ പേജ് Wing 2 ഉപയോക്താക്കൾക്ക് മാത്രം ലഭ്യമാണ്.
    </div>

    <div v-else>
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border text-primary" role="status"></div>
      </div>

      <div v-else-if="savedCenters.length > 0" class="saved-centers-section">
        <h4 class="section-title mal-text">പരീക്ഷാ കേന്ദ്രങ്ങൾ</h4>
        <div class="saved-centers-list">
          <div v-for="(center, idx) in savedCenters" :key="center.id || idx" class="saved-center-card">
            <div class="center-info">
              <strong class="center-name">{{ getCenterName(center) }}</strong>
              <span class="center-detail" v-if="getCenterTypeLabel(center)">തരം: {{ getCenterTypeLabel(center) }}</span>
              <span class="center-detail">കോഡിനേറ്റർ: {{ center.convenor_name }}</span>
              <span class="convenor-phone">
                <a v-if="center.convenor_phone" :href="'tel:' + center.convenor_phone">{{ center.convenor_phone }}</a>
                <template v-else>{{ center.convenor_phone || '-' }}</template>
              </span>
            </div>
            <div class="center-actions" v-if="canAddCenter">
              <button type="button" class="btn btn-sm btn-outline-primary" @click="openEditModal(center)">എഡിറ്റ്</button>
              <button type="button" class="btn btn-sm btn-outline-danger" @click="confirmDelete(center)">ഡിലീറ്റ്</button>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="empty-note mal-text">ഇതുവരെ പരീക്ഷാ കേന്ദ്രങ്ങൾ ചേർത്തിട്ടില്ല.</div>
    </div>

    <!-- Add/Edit Modal -->
    <div v-if="formModalOpen" class="modal-overlay action-sheet-open" @click.self="closeFormModal">
      <div class="modal-sheet">
        <div class="modal-sheet-handle"></div>
        <h5 class="modal-title mal-text">{{ editingId ? 'പരീക്ഷാ കേന്ദ്രം എഡിറ്റ് ചെയ്യുക' : 'പരീക്ഷാ കേന്ദ്രം ചേർക്കുക' }}</h5>
        <form @submit.prevent="submitFormModal">
          <div class="form-group">
            <label class="form-label mal-text">പരീക്ഷാ കേന്ദ്രം പേര് (Center Name) <span class="text-danger">*</span></label>
            <input v-model="form.madrasa_name" type="text" class="form-control" placeholder="പരീക്ഷാ കേന്ദ്രത്തിന്റെ പേര്" required />
          </div>
          <div class="form-group">
            <label class="form-label mal-text">Type of Centre <span class="text-danger">*</span></label>
            <select v-model="form.center_type" class="form-control" required>
              <option value="" disabled class="mal-text">തിരഞ്ഞെടുക്കുക</option>
              <option v-for="opt in centerTypeOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label mal-text">സെൻ്റർ കോഡിനേറ്ററുടെ പേര്? <span class="text-danger">*</span></label>
            <input v-model="form.convenor_name" type="text" class="form-control" placeholder="കോഡിനേറ്ററുടെ പേര്" required />
          </div>
          <div class="form-group">
            <label class="form-label mal-text">സെൻ്റർ കോഡിനേറ്ററുടെ നമ്പർ? <span class="text-danger">*</span></label>
            <input v-model="form.convenor_phone" type="tel" class="form-control" placeholder="10 അക്ക മൊബൈൽ നമ്പർ" maxlength="10" inputmode="numeric" required />
          </div>
          <div class="form-group">
            <label class="form-label mal-text">Exam Start Time <span class="text-danger">*</span></label>
            <input v-model="form.exam_start_time" type="time" class="form-control" required />
          </div>
          <div class="form-group">
            <label class="form-label mal-text">Exam End Time <span class="text-danger">*</span></label>
            <input v-model="form.exam_end_time" type="time" class="form-control" required />
          </div>
          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeFormModal">ക്യാൻസൽ</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">{{ saving ? 'സേവ് ചെയ്യുന്നു...' : 'സേവ് ചെയ്യുക' }}</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Delete confirm modal -->
    <div v-if="deleteModalOpen" class="modal-overlay" @click.self="deleteModalOpen = false">
      <div class="modal-box modal-confirm">
        <h5 class="modal-title mal-text">ഡിലീറ്റ് ചെയ്യണോ?</h5>
        <p class="mal-text" v-if="centerToDelete">{{ getCenterName(centerToDelete) }} - ഈ പരീക്ഷാ കേന്ദ്രം ഡിലീറ്റ് ചെയ്യുമോ?</p>
        <div class="modal-actions">
          <button type="button" class="btn btn-secondary" @click="deleteModalOpen = false">ക്യാൻസൽ</button>
          <button type="button" class="btn btn-danger" :disabled="deleteSaving" @click="submitDelete">{{ deleteSaving ? 'ഡിലീറ്റ് ചെയ്യുന്നു...' : 'ഡിലീറ്റ്' }}</button>
        </div>
      </div>
    </div>

    <!-- Alert -->
    <div class="modal fade action-sheet" id="actionSheetAlert" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="action-sheet-content">
              <div class="iconbox text-success" v-if="alertClass === 'alert-success'">
                <ion-icon name="checkmark-circle"></ion-icon>
              </div>
              <div class="iconbox text-danger" v-if="alertClass === 'alert-error'">
                <ion-icon name="close-circle"></ion-icon>
              </div>
              <div class="text-center p-2">
                <h3>{{ alertClass === 'alert-success' ? ($t('success') || 'Success') : ($t('error') || 'Error') }}</h3>
                <p class="mal-text text-primary">{{ alertMessage }}</p>
              </div>
              <a href="javascript:void(0)" class="btn btn-primary btn-lg btn-block" @click="closeAlertModal">
                {{ $t('close') || 'Close' }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '../services/user.service';
import $ from 'jquery';

export default {
  name: 'QHLSExamCenter',
  data() {
    return {
      loading: false,
      saving: false,
      deleteSaving: false,
      savedCenters: [],
      formModalOpen: false,
      deleteModalOpen: false,
      editingId: null,
      centerToDelete: null,
      form: {
        madrasa_name: '',
        center_type: '',
        convenor_name: '',
        convenor_phone: '',
        exam_start_time: '',
        exam_end_time: '',
      },
      centerTypeOptions: [
        { value: 'masjid', label: 'Masjid' },
        { value: 'madrasa', label: 'Madrasa' },
        { value: 'school', label: 'School' },
        { value: 'rental_room', label: 'Rental Room' },
      ],
      alertMessage: '',
      alertClass: 'alert-success',
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    /** Matches router `/org/:sub_level/:id/...` (2=district, 3=zone, 4=unit). */
    routeSubLevel() {
      const raw = this.$route.params?.sub_level;
      const n = parseInt(String(raw ?? ''), 10);
      return Number.isNaN(n) ? null : n;
    },
    routeEntityId() {
      const raw = this.$route.params?.id;
      if (raw == null || raw === '') return null;
      const n = parseInt(String(raw), 10);
      return Number.isNaN(n) ? null : n;
    },
    zoneId() {
      const sl = this.routeSubLevel;
      if (sl === 3 && this.routeEntityId != null) return this.routeEntityId;
      const z = this.currentUser?.zone_id;
      if (z == null) return null;
      const n = parseInt(String(z), 10);
      return Number.isNaN(n) ? null : n;
    },
    unitId() {
      const sl = this.routeSubLevel;
      if (sl === 4 && this.routeEntityId != null) return this.routeEntityId;
      const u = this.currentUser?.unit_id;
      if (u == null) return null;
      const n = parseInt(String(u), 10);
      return Number.isNaN(n) ? null : n;
    },
    districtId() {
      return this.currentUser?.district_id || null;
    },
    userLevel() {
      const raw = this.currentUser?.user_level;
      if (raw == null) return 0;
      const n = parseInt(raw, 10);
      return Number.isNaN(n) ? 0 : n;
    },
    isWing2() {
      const w = this.currentUser?.wing_id ?? this.currentUser?.wing ?? this.currentUser?.wing_type;
      const n = parseInt(String(w ?? ''), 10);
      return n === 2;
    },
    canAddCenter() {
      return (
        this.userLevel == 1
        || this.userLevel == 2
        || this.userLevel == 3
        || this.userLevel == 4
      );
    },
  },
  watch: {
    '$route.params.id'(newVal, oldVal) {
      if (newVal !== oldVal && this.canAddCenter && this.zoneId && this.isWing2) {
        this.fetchSavedCenters();
      }
    },
    '$route.params.sub_level'(newVal, oldVal) {
      if (newVal !== oldVal && this.canAddCenter && this.zoneId && this.isWing2) {
        this.fetchSavedCenters();
      }
    },
  },
  mounted() {
    this.$root.updateParent('QHLS പരീക്ഷാ കേന്ദ്രം');
    if (this.canAddCenter && this.zoneId && this.isWing2) {
      this.fetchSavedCenters();
    }
  },
  methods: {
    async fetchSavedCenters() {
      if (!this.zoneId) return;
      try {
        this.loading = true;
        const params = { zone_id: this.zoneId };
        if (this.unitId) params.unit_id = this.unitId;
        const response = await UserService.authGetRequest('qhls-exam-centers', params);
        if (response.data.status === 'success' && Array.isArray(response.data.data?.list)) {
          this.savedCenters = response.data.data.list;
        } else {
          this.savedCenters = [];
        }
      } catch (err) {
        console.warn('Could not load saved centers:', err);
        this.savedCenters = [];
      } finally {
        this.loading = false;
      }
    },
    getCenterName(center) {
      if (center.madrasa_name) return center.madrasa_name;
      if (center.madrasa && center.madrasa.name) return center.madrasa.name;
      return (center.convenor_name || '');
    },
    normalizeCenterType(raw) {
      if (raw == null || raw === '') return '';
      const s = String(raw).trim().toLowerCase().replace(/\s+/g, '_');
      const map = {
        masjid: 'masjid',
        madrasa: 'madrasa',
        school: 'school',
        rental_room: 'rental_room',
        rentalroom: 'rental_room',
        'rental room': 'rental_room',
      };
      return map[s] || (['masjid', 'madrasa', 'school', 'rental_room'].includes(s) ? s : '');
    },
    getCenterTypeLabel(center) {
      const v = this.normalizeCenterType(center?.center_type ?? center?.centre_type ?? center?.type_of_centre);
      const opt = this.centerTypeOptions.find((o) => o.value === v);
      return opt ? opt.label : '';
    },
    openAddModal() {
      this.editingId = null;
      this.form = { madrasa_name: '', center_type: '', convenor_name: '', convenor_phone: '', exam_start_time: '', exam_end_time: '' };
      this.formModalOpen = true;
    },
    openEditModal(center) {
      this.editingId = center.id;
      this.form = {
        madrasa_name: this.getCenterName(center),
        center_type: this.normalizeCenterType(center.center_type ?? center.centre_type ?? center.type_of_centre),
        convenor_name: center.convenor_name || '',
        convenor_phone: (center.convenor_phone || '').replace(/\D/g, ''),
        exam_start_time: center.exam_start_time ? (String(center.exam_start_time).length > 5 ? String(center.exam_start_time).substring(0, 5) : center.exam_start_time) : '',
        exam_end_time: center.exam_end_time ? (String(center.exam_end_time).length > 5 ? String(center.exam_end_time).substring(0, 5) : center.exam_end_time) : '',
      };
      this.formModalOpen = true;
    },
    closeFormModal() {
      this.formModalOpen = false;
      this.editingId = null;
    },
    showAlert(msg, type = 'success') {
      this.alertMessage = msg;
      this.alertClass = type === 'error' ? 'alert-error' : 'alert-success';
      this.$nextTick(() => {
        $('#actionSheetAlert').modal('show');
      });
    },
    closeAlertModal() {
      $('#actionSheetAlert').modal('hide');
      this.alertMessage = '';
      this.alertClass = 'alert-success';
    },
    validatePhone(phone) {
      const p = String(phone || '').replace(/\D/g, '');
      return p.length === 10;
    },
    async submitFormModal() {
      if (!this.canAddCenter || !this.isWing2) {
        this.showAlert('ഈ നടപടി അനുവദനീയമല്ല', 'error');
        return;
      }
      if (!this.form.madrasa_name?.trim() || !this.form.center_type || !this.form.convenor_name || !this.form.convenor_phone || !this.form.exam_start_time || !this.form.exam_end_time) {
        this.showAlert('എല്ലാ ഫീൽഡുകളും പൂരിപ്പിക്കുക', 'error');
        return;
      }
      if (!this.validatePhone(this.form.convenor_phone)) {
        this.showAlert('സാധുവായ 10 അക്ക ഫോൺ നമ്പർ നൽകുക', 'error');
        return;
      }
      if (!this.zoneId) {
        this.showAlert('സോൺ വിവരം കണ്ടെത്തിയില്ല', 'error');
        return;
      }
      try {
        this.saving = true;
        const madrasaName = this.form.madrasa_name.trim();

        if (this.editingId) {
          const response = await UserService.authPostRequest(`qhls-exam-center/${this.editingId}`, {
            madrasa_id: null,
            madrasa_name: madrasaName,
            center_type: this.form.center_type,
            convenor_name: this.form.convenor_name?.trim(),
            convenor_phone: this.form.convenor_phone.trim().replace(/\D/g, ''),
            exam_start_time: this.form.exam_start_time || null,
            exam_end_time: this.form.exam_end_time || null,
            unit_id: this.unitId || null,
          });
          if (response.data.status === 'success') {
            this.showAlert('വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു');
            this.closeFormModal();
            this.fetchSavedCenters();
          } else {
            this.showAlert(response.data.message || 'അപ്ഡേറ്റ് ചെയ്യുന്നതിൽ പിശക്', 'error');
          }
        } else {
          const payload = {
            madrasa_id: null,
            madrasa_name: madrasaName,
            center_type: this.form.center_type,
            convenor_name: this.form.convenor_name?.trim(),
            name: this.form.convenor_name?.trim(),
            convenor_phone: this.form.convenor_phone.trim().replace(/\D/g, ''),
            exam_start_time: this.form.exam_start_time || null,
            exam_end_time: this.form.exam_end_time || null,
            zone_id: this.zoneId,
            unit_id: this.unitId || null,
          };
          const response = await UserService.authPostRequest('qhls-exam-center/store', payload);
          if (response.data.status === 'success') {
            this.showAlert('വിജയകരമായി സേവ് ചെയ്തു');
            this.closeFormModal();
            this.fetchSavedCenters();
          } else {
            this.showAlert(response.data.message || 'സേവ് ചെയ്യുന്നതിൽ പിശക്', 'error');
          }
        }
      } catch (err) {
        const msg = err.response?.data?.message || 'സേവ് ചെയ്യുന്നതിൽ പിശക്';
        this.showAlert(msg, 'error');
      } finally {
        this.saving = false;
      }
    },
    confirmDelete(center) {
      this.centerToDelete = center;
      this.deleteModalOpen = true;
    },
    async submitDelete() {
      if (!this.centerToDelete) return;
      try {
        this.deleteSaving = true;
        const response = await UserService.authPostRequest(`qhls-exam-center-delete/${this.centerToDelete.id}`, {});
        if (response.data.status === 'success') {
          this.showAlert('വിജയകരമായി ഡിലീറ്റ് ചെയ്തു');
          this.deleteModalOpen = false;
          this.centerToDelete = null;
          this.fetchSavedCenters();
        } else {
          this.showAlert(response.data.message || 'ഡിലീറ്റ് ചെയ്യുന്നതിൽ പിശക്', 'error');
        }
      } catch (err) {
        this.showAlert(err.response?.data?.message || 'ഡിലീറ്റ് ചെയ്യുന്നതിൽ പിശക്', 'error');
      } finally {
        this.deleteSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.qhls-exam-center {
  max-width: 480px;
  margin: 0 auto;
  padding: 16px;
}
.page-header {
  margin-bottom: 20px;
}
.page-subtitle {
  font-size: 0.9rem;
  color: #6c757d;
}
.add-btn-wrap {
  margin-bottom: 16px;
}
.add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
}
.add-btn ion-icon {
  font-size: 1.25rem;
}
.saved-centers-section {
  margin-top: 8px;
}
.section-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 12px;
  color: #1a418c;
}
.saved-centers-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.saved-center-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.center-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}
.center-info .center-name {
  font-size: 1rem;
  color: #1a418c;
}
.center-info .center-detail {
  font-size: 0.9rem;
  color: #6c757d;
}
.center-info .convenor-phone {
  font-size: 0.9rem;
  color: #1a418c;
}
.center-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.empty-note {
  margin-top: 18px;
  text-align: center;
  color: #6c757d;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 9999;
  padding: 0;
}
.modal-overlay.action-sheet-open {
  align-items: flex-end;
}
.modal-sheet {
  background: #fff;
  border-radius: 16px 16px 0 0;
  padding: 20px;
  width: 100%;
  max-width: 480px;
  max-height: 85vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease;
}
.modal-sheet-handle {
  width: 36px;
  height: 4px;
  background: #dee2e6;
  border-radius: 2px;
  margin: 0 auto 16px;
}
.modal-sheet .modal-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: #1a418c;
}
.form-group {
  margin-bottom: 14px;
}
.form-label {
  display: block;
  font-weight: 500;
  margin-bottom: 6px;
  color: #333;
}
.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
}
.modal-sheet .modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}
.modal-box {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  max-width: 400px;
  width: 100%;
  margin: 16px;
}
.modal-box.modal-confirm .modal-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 12px;
}
.modal-box .modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 16px;
}
.modal-confirm p {
  margin-bottom: 16px;
  font-size: 0.95rem;
  color: #333;
}
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
